import React, { Component } from 'react';
import './App.scss';

import UserSetting from './pages/User/UserSetting';

import BiddingManage from './pages/BiddingManage';
import TenderManage from './pages/TenderManage';

import { cookie } from './approach/base';

import { HashRouter, Switch, Route, Link } from 'react-router-dom';
import {
    ContainerOutlined,
} from '@ant-design/icons';

import { Layout, Menu } from 'antd';
const { SubMenu } = Menu;

export default class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            openKeys: [],
            selectedKeys: ["administrator"],
            menus: []
        };
    }

    componentDidMount() {
        window.$axios.initRequest.setEnv(null, { "x-csrftoken":cookie.get("csrftoken") });
        window.$Store.subscribe(() => {
            // 使用setState中只放一个空对象会更新所有的数据
            // 目的就是触发render的执行, 来重新渲染页面, 让页面的数据发生改变
            this.setState({})
        })
        console.log(this.props.location.pathname)
        let path = this.props.location.pathname;
        this.setState({
            openKeys: path.split('/').length > 2 ? ['/' + path.split('/')[1]] : [],
            selectedKeys: [path]
        });
    }

    onClick = item => {
        this.setState({
            selectedKeys: [item.key]
        });
    };

    render() {
        return (
            <Layout style={{ width: '100%', height: '100%' }}>
                <Layout>
                    <Layout.Sider
                        breakpoint="md"
                        trigger={null}
                        collapsible
                        collapsed={this.state.collapsed}
                        className="Layout-Sider"
                        theme={'light'}
                    >
                        <div className="logo">
                            管理平台
                        </div>
                        <Menu
                            mode="inline"
                            theme="dark"
                            // openKeys={this.state.openKeys}
                            selectedKeys={this.state.selectedKeys}
                            onClick={this.onClick}
                            // mode="vertical"
                        >
                            <SubMenu
                                key="/manage"
                                icon={<ContainerOutlined />}
                                title="招标管理"
                            >
                                <Menu.Item key="/manage/bidding" icon={<ContainerOutlined />}>
                                    <Link to="/manage/bidding">招标信息</Link>
                                </Menu.Item>
                                <Menu.Item key="/manage/tender" icon={<ContainerOutlined />}>
                                    <Link to="/manage/tender">投标信息</Link>
                                </Menu.Item>
                            </SubMenu>
                        </Menu>
                    </Layout.Sider>
                    <Layout.Content>
                        <Layout.Header
                            className="Layout-Header"
                        >
                            <div></div>
                            <div className="HeaderMain">
                                <UserSetting />
                            </div>
                        </Layout.Header>
                        <div
                            className="myCotent"
                        >
                            <HashRouter>
                                <Switch>
                                    <Route exact path="/manage/bidding" component={BiddingManage} />
                                    <Route exact path="/manage/tender" component={TenderManage} />
                                </Switch>
                            </HashRouter>
                        </div>
                    </Layout.Content>
                </Layout>
            </Layout>
        );
    }
}
